export const ENDPOINTS = {
  geminiToken: `/gemini/token`,
  suggestJobs: (sessionId: string) =>
    `/sessions/${sessionId}/jobs/suggest_jobs`,
  userData: (userId: string) => `/users/${userId}`,
  logConversation: `/log_conversation`,
  feedback: `/feedback`,
  updateRecommendationAction: (recommendationId: number) =>
    `/recommendations/${recommendationId}/action`,
  salaryRange: (country: string) => `/salary-range/${country}`,
};
